import axios, { AxiosRequestConfig, AxiosInstance } from 'axios'
import { Message, MessageBox } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import {NEW_URL, BASE_URL, headerCaState } from '@/config'
import { MessageBoxData } from 'element-ui/types/message-box'

// 返回类型

/* eslint-disable */
declare global {
  namespace Ajax {
    interface Response<T = any> {
      content: T
      code: number
      success: boolean
      errorMsg: string | null
    }
  }
}

// 重写AxiosInstance
export interface CusxiosInstance extends AxiosInstance {
  <T = any>(config: AxiosRequestConfig): Promise<T>
  request<T = any> (config: AxiosRequestConfig): Promise<T>
  get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>
  delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>
  head<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>
  post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>
  put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>
  patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>
}

const service: CusxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 5000,
  headers: {
    'X-Ca-Stage': headerCaState()
  }
})

// Request interceptors
service.interceptors.request.use(
  (config) => {
    if (UserModule.token) {
      config.headers.Authorization = UserModule.token
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

let MessageBoxInstance: Promise<void | MessageBoxData> | null

// Response interceptors
service.interceptors.response.use(
  (response) => {
    // Some example codes here:
    // code == 200: success
    // code == 401: invalid access
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        if (!MessageBoxInstance) {
          MessageBoxInstance = MessageBox.alert(
            '登录已过期，请尝试重新登录',
            '提示',
            {
              confirmButtonText: '重新登录',
              type: 'warning',
              showClose: false
            }
          ).then(() => {
            MessageBoxInstance = null
            UserModule.ResetToken()
            location.reload() // To prevent bugs from vue-router
          })
        }
      } else {
        Message({
          message: res.errorMsg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error(res.errorMsg || 'Error'))
    } else {
      return response.data
    }
  },
  (error) => {
    if (error.message.includes('timeout')) {
      Message({
        message: '请求已超时，网络竟然开了小差~~',
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      Message({
        message: '服务异常，请稍后重试',
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error.response)
  }
)

const newservice: CusxiosInstance = axios.create({
  baseURL: NEW_URL,
  timeout: 5000,
  headers: {
    'X-Ca-Stage': headerCaState()
  }
})
// Request interceptors
newservice.interceptors.request.use(
  (config) => {
    if (UserModule.token) {
      config.headers.Authorization = UserModule.token
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)
// Response interceptors
newservice.interceptors.response.use(
  (response) => {
    const res = response.data
    let errorMsg;
    if(res.code){
      Message({
        message: res.errorMsg||res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      errorMsg=res.errorMsg;
    }else{
      let data=JSON.parse(JSON.stringify(response.data));
      data.success=data.ok;
      data.content=data.data;
      data.errorMsg=data.msg;
      if(Object.prototype.toString.call(data.content)=='[object Object]'){
        data.content.currentPage=data.content.current;
        data.content.content=data.content.records;
      }
      return data;
    }
    return Promise.reject(new Error(errorMsg))
  },
  ({response}) => {
    let errorMsg;
    switch (response.status){
      case 401:
        Message({
          message: '没有权限',
          type: 'error',
          duration: 5 * 1000
        })
        errorMsg='没有权限'
        break;
      case 400:
        if (!MessageBoxInstance) {
          MessageBoxInstance = MessageBox.alert(
            '登录已过期，请尝试重新登录',
            '提示',
            {
              confirmButtonText: '重新登录',
              type: 'warning',
              showClose: false
            }
          ).then(() => {
            MessageBoxInstance = null
            UserModule.ResetToken()
            location.reload() // To prevent bugs from vue-router
            errorMsg='登录已过期，请尝试重新登录'
          })
        }
        break;
    }
    return Promise.reject(response)
  }
)
export let newRequest=newservice;

export default service
